import request from '@/utils/request'
const api = {
  apply: 'user_apply/apply',
  getApply: 'user_apply/getApply'
}
export default {
  apply(parameter) {
    return request({
      url: api.apply,
      method: 'POST',
      data: parameter
    })
  },
  getApply(parameter) {
    return request({
      url: api.getApply,
      method: 'POST',
      data: parameter
    })
  }
}
